module.exports = __webpack_public_path__ + "img/1.e5c4e3ff.png";